<template>
  <div class="contact">
    <div class="container" :class="{active: show}">
      <span>Contact</span>
      <h1>Let's Work Together!</h1>

      <template v-if="!loading">
        <div class="description" v-html="informations.userAbout" />

        <div class="mail">
          <p>Send me an Email to <a :href="`mailto:${informations.userEmail}`">{{ informations.userEmail }}</a></p>
        </div>

        <div class="instagram">
          <p>& Follow me </p>
          <LinkInstagram :pseudo="instagram.userInstagramPseudo" :name="instagram.userInstagramName"/>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { CONTACT } from '../queries'
import { useShowTimeout } from '../compositions/useShowTimeout'
import { useQuery, useResult } from '@vue/apollo-composable'

import LinkInstagram from '../components/LinkInstagram'

export default {
  name: 'Contact',
  components: {
    LinkInstagram
  },
  head: {
    title: {
      inner: 'Contact | OriginalFake Photography | 2020 | Paris - FRANCE'
    },
  },
  setup() {
    const show = useShowTimeout(1000)

    const { result, loading } = useQuery(CONTACT)
    const instagram = useResult(result, null, data => data.siteGeneralSettings.instagram)
    const informations = useResult(result, null, data => data.siteGeneralSettings.informations)

    return {
      show, 
      loading,
      instagram,
      informations
    }
  }
}
</script>

<style lang="scss" scoped>
  .container {
    @extend %container;

    margin-top: 8rem;
  }

  span {
    @extend %font-regular;
    line-height: 0.4rem;
    font-size: 0.4rem;
    letter-spacing: 0.5rem;
    transition: opacity 0.8s $ease-out, letter-spacing 1s $ease-out;
    opacity: 0;

    .active & {
      opacity: 1;
      letter-spacing: 0.2rem;
    }
  }

  h1 {
    @extend %font-bold;

    font-size: 3rem;
    line-height: 2.5rem;
    opacity: 0;
    color: $red;
    margin-bottom: 1rem;
      
    letter-spacing: 0.5rem;
    transition: opacity 0.8s 0.4s $ease-out, letter-spacing 1s 0.4s $ease-out;

    .active & {
      opacity: 1;
      letter-spacing: 0;
    }
  }

  .description {
    margin-bottom: 1rem;
    opacity: 0;
    transition: opacity 0.8s 1s $ease-out;

    .active & {
      opacity: 1;
    }
  }

  .instagram,
  .mail {
    display: flex;
    opacity: 0;
    transition: opacity 0.8s 1.4s $ease-out;

    p {
      @extend %font-bold;

      margin-right: 1rem;
      font-size: 2rem;
      line-height: initial;
    }

    .active & {
      opacity: 1;
    }
  }
</style>
